import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpParams } from '@angular/common/http';
import { ParamMap } from '@angular/router';
import { Observable, combineLatest, Subject, BehaviorSubject, ReplaySubject } from 'rxjs';
import { map, filter, tap, switchAll } from 'rxjs/operators';
import { ShopFull } from '../models/shop-full.model';
import { Real } from '../models/real.model';
import { List } from '../models/list.model';
import { Day } from '../models/day.model';
import { Service } from '../models/cart/service.model';
import { Slot } from '../models/cart/slot.model';
import { Combination } from '../models/cart/combination.model';
import { environment } from '../../../environments/environment';
import * as moment from 'moment';
import 'moment-timezone';
import 'moment/locale/sl';
moment.tz.setDefault("Europe/Ljubljana");

@Injectable({
  providedIn: 'root'
})
export class PickSlotService {

  constructor( private http: HttpClient ) { }  

  getDays( real: Real, partySize: number ) {

    const responseToList = ( response ): List => {

      let list = new List( { 'totalCount': response.totalCount } );

      if ( response._embedded && response._embedded.day ) {
        
        list.items = response._embedded.day.map(
          day => new Day( day )
        )
        
      } 

      return list;

    };

    let providerId = real.provider.id;
    let selectionItemId = real.selectionItems[0].id;

    let url = environment.apiUrl + '/providers/' + providerId + '/days';

    let httpParams = new HttpParams();

    httpParams = httpParams.append( 'pageSize', '180' );
    httpParams = httpParams.append( 'bookingType', 'table' );
    httpParams = httpParams.append( 'partySize', partySize.toString() );
    httpParams = httpParams.append( 'realSelectionItem', environment.apiUrl + '/providers/' + providerId + '/services/23/selectionitems/' + selectionItemId );

    /*const services = [
      'https://api.pricepilot.io/providers/' + providerId + '/services/' + '4778' 
    ];*/

    /*services.forEach( pickedService => {
      httpParams = httpParams.append( 'attendees[0][services][]', pickedService.url );
    });*/


    return this.http.get( url, { params: httpParams } ).pipe(

      map( response => responseToList( response ) )

    );

  }

  getSlotCombinations( hour: string, day: string, real: Real, partySize: number ): Observable<Array<Combination>> {

    const responseToList = ( response ): List => {

      let list = new List( { 'totalCount': response.totalCount } );

      if ( response._embedded && response._embedded.combination ) {
        
        list.items = response._embedded.combination.map(
          combination => new Combination( combination )
        )
        
      } 

      return list;

    };

    let providerId = real.provider.id;
    let selectionItemId = real.selectionItems[0].id;

    let url = environment.apiUrl + '/providers/' + providerId + '/days/' + day + '/slots/' + hour + '/combinations';

    let httpParams = new HttpParams();
    httpParams = httpParams.append( 'pageSize', '90' );
    httpParams = httpParams.append( 'bookingType', 'table' );
    httpParams = httpParams.append( 'partySize', partySize.toString() );

    httpParams = httpParams.append( 'realSelectionItem', environment.apiUrl + '/providers/' + providerId + '/services/4778/selectionitems/' + selectionItemId );

    /*const services = [
      'https://api.pricepilot.io/providers/' + providerId + '/services/' + '4778' 
    ];*/

    /*pickedServices.forEach( pickedService => {
      httpParams = httpParams.append( 'attendees[0][services][]', pickedService.url );
    });*/

    httpParams = httpParams.append( 'pageSize', '100' );  

    return this.http.get( url, { params: httpParams } ).pipe(
     map( (response: any) => {
       if ( response._embedded && response._embedded.combination ) {
         return response._embedded.combination;
       } else {
         return [];
       }
     }),
     map( (slotsApiArr: Array<any>): Array<Combination> => {
       return slotsApiArr.map( combinationApiObj => new Combination( combinationApiObj ) );
     })
     //map( response => responseToList( response ) )

    );



 /*http://api.pricepilot.loc/app_dev.php/providers/48/days/2018-07-16/slots/08:00:00+0200/combinations?attendees%5B0%5D%5Bservices%5D%5B0%5D=http%3A%2F%2Fapi.pricepilot.loc%2Fapp_dev.php%2Fproviders%2F48%2Fservices%2F3703&realSelectionItem=http%3A%2F%2Fapi.pricepilot.loc%2Fapp_dev.php%2Fproviders%2F48%2Fservices%2F3667%2Fselectionitems%2F511&pageSize=100
*attendees[0][services][0]:http://api.pricepilot.loc/app_dev.php/providers/48/services/3703
*realSelectionItem:http://api.pricepilot.loc/app_dev.php/providers/48/services/3667/selectionitems/511
*pageSize:100
*/


  }

  getDaySlots( day: string, real: Real, partySize: number /*pickedServices: Service[]*/ ): Observable<Array<Slot>> {

    const responseToList = ( response ): List => {

      let list = new List( { 'totalCount': response.totalCount } );

      if ( response._embedded && response._embedded.day ) {
        
        list.items = response._embedded.day.map(
          day => new Day( day )
        )
        
      } 

      return list;

    };

    let providerId = real.provider.id;
    let selectionItemId = real.selectionItems[0].id;

    let url = environment.apiUrl + '/providers/' + providerId + '/days/' + day + '/slots';


    let httpParams = new HttpParams();

    httpParams = httpParams.append( 'bookingType', 'table' );
    httpParams = httpParams.append( 'partySize', partySize.toString() );
    httpParams = httpParams.append( 'realSelectionItem', environment.apiUrl + '/providers/' + providerId + '/services/4778/selectionitems/' + selectionItemId );

    /*const services = [
      'https://api.pricepilot.io/providers/' + providerId + '/services/' + '4778' 
    ];*/

    /*pickedServices.forEach( pickedService => {
      httpParams = httpParams.append( 'attendees[0][services][]', pickedService.url );
    });*/


    return this.http.get( url, { params: httpParams } ).pipe(
     map( (response: any) => {
       if ( response._embedded && response._embedded.slot ) {
         return response._embedded.slot;
       } else {
         return [];
       }
     }),
     map( (slotsApiArr: Array<any>): Array<Slot> => {
       return slotsApiArr.map( slotApiObj => new Slot(slotApiObj) );
     })
     //map( response => responseToList( response ) )

    );

  }

  getMorningSlots( daySlots$ ) {
    return daySlots$.pipe(
     map( (response: Slot[]) => {
       return response.filter(slot => parseInt( moment(slot.start).format('H') ) < 12);
     })
    );
  }

  getAfternoonSlots( daySlots$ ) {
    return daySlots$.pipe(
     map( (response: Slot[]) => {
       return response.filter(slot => parseInt( moment(slot.start).format('H') ) >= 12);
     })
    );
  }
  
}
